





import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "bs-form-group"
})
export default class BsFormGroupComponent extends Vue {
 
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/bootstrap/bs-form-group.vue